/* Copyright 2022 VMware, Inc. All rights reserved. VMware Confidential */

export class ConsoleStrings {
    name: string = "general.UNDEFINED_STRING";
    shortName: string = "general.UNDEFINED_STRING";
    serviceDescription: string = "general.UNDEFINED_STRING";
    htmlTitle: string = "general.UNDEFINED_STRING";
    htmlTitleDefault: string = "general.UNDEFINED_STRING";
}

export const VLR_STRINGS: ConsoleStrings = {
    name: "vlr.console.app.name",
    shortName: "vlr.console.app.name.short",
    serviceDescription: "console.slow.rollout.initial.description.vlr",
    htmlTitle: "vlr.console.html.title",
    htmlTitleDefault: "vlr.console.html.title.default"
}

export const VMCFS_STRINGS: ConsoleStrings = {
    name: "vmcfs.console.app.name",
    shortName: "vmcfs.console.app.name.short",
    serviceDescription: "console.slow.rollout.initial.description.vmcfs",
    htmlTitle: "vmcfs.console.html.title",
    htmlTitleDefault: "vmcfs.console.html.title.default"
}

export const OPERATOR_STRINGS: ConsoleStrings = {
    name: "op.console.csp.header.title",
    shortName: "op.console.csp.header.title",
    serviceDescription: "console.slow.rollout.initial.description.vlcr",
    htmlTitle: "op.console.html.title",
    htmlTitleDefault: "op.console.html.title.default"
}
